import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {ArrowUpRightIcon, type Icon} from '@primer/octicons-react'
import styles from './MiniMergeSections.module.css'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'
import {isForYouRefreshEnabled} from '../../shared/for-you-feature-flags'

export function MiniStatusSkeletonItem({
  text,
  action,
  icon,
  isFirst,
}: {
  text?: string
  action?: (returnFocusTo?: HTMLElement | null) => void
  icon?: Icon
  isFirst?: boolean
}) {
  const actionIcon = action ? (icon ?? ArrowUpRightIcon) : undefined
  const loadingIconTestId = `mini-status-loading-icon-${text?.toLowerCase().replaceAll(' ', '-') ?? 'status'}`
  const isRefreshEnabled = isForYouRefreshEnabled()
  const label = isRefreshEnabled
    ? action
      ? `Loading. View ${text ?? 'details'}`
      : `${text ?? 'Merge status'} loading`
    : action
      ? `View ${text ?? 'details'}`
      : 'Loading merge status'

  return (
    <MiniMergeStatusItem
      aria-label={label}
      isFirst={isFirst}
      onClick={action ? event => action(event.currentTarget) : undefined}
    >
      <MiniMergeStatusItem.LabelRow icon={actionIcon}>
        <span className="d-flex flex-items-center gap-1">
          {isRefreshEnabled ? (
            <LoadingSkeleton
              aria-hidden="true"
              data-testid={loadingIconTestId}
              variant="rounded"
              width="16px"
              height="16px"
            />
          ) : null}
          {text ? (
            <MiniMergeStatusItem.Label>{text}</MiniMergeStatusItem.Label>
          ) : (
            <LoadingSkeleton variant="text" width="80px" />
          )}
        </span>
        {!action ? (
          <LoadingSkeleton variant="rounded" width="20px" height="20px" className={styles.MiniStatusLoadingIcon} />
        ) : null}
      </MiniMergeStatusItem.LabelRow>
      <LoadingSkeleton className={styles.MiniStatusProgress} variant="rounded" height="8px" />
    </MiniMergeStatusItem>
  )
}
